// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NumberScroll_wrapper__GqnRS"};